'use strict';

angular.module('controllers')
	.directive('expandCollapseContents', function() {
		return {
			restrict: 'EA',
			scope: false ,
			link: function(scope, element, attrs){
				var el = angular.element(element[0].querySelector('#collapse-button'));
				el.bind('click', function (event) {
					angular.element(document.querySelector('.expand-collapse-contents')).slideToggle('200',function() {
						angular.element(el[0].querySelector('i')).toggleClass('fa-chevron-down fa-chevron-up');
					});
				});

			}
		}

	});